import type { TextareaHTMLAttributes } from 'react'
import { forwardRef } from 'react'
import { cn } from '@/lib/cn'

interface Props extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string
  error?: string
  /** Texto de apoio abaixo do campo. O erro tem prioridade sobre ele. */
  hint?: string
  wrapperClassName?: string
}

export const Textarea = forwardRef<HTMLTextAreaElement, Props>(function Textarea(
  { label, error, hint, className, wrapperClassName, required, ...rest },
  ref,
) {
  const hasError = Boolean(error)
  return (
    <div className={cn('flex flex-col', wrapperClassName)}>
      {label && (
        <label className="text-xs font-medium text-gray-700 mb-1">
          {label}{required && <span className="text-rose-500 ml-0.5">*</span>}
        </label>
      )}
      <textarea
        ref={ref}
        // Regra global: autocomplete desligado por default e required apenas
        // visual (sem propagar pro DOM — validação é 100% via zod/RHF).
        autoComplete="off"
        autoCorrect="off"
        spellCheck={false}
        {...rest}
        className={cn(
          'w-full bg-white rounded-md ring-1 text-sm text-gray-900 px-3 py-2 transition resize-y min-h-[88px]',
          hasError ? 'ring-rose-300 focus:ring-rose-500' : 'ring-gray-200 focus:ring-brand-500 focus:ring-2',
          'focus:outline-none placeholder:text-gray-400',
          className,
        )}
      />
      {(error || hint) && (
        <span className={cn('text-[11px] mt-1', error ? 'text-rose-600' : 'text-gray-500')}>
          {error || hint}
        </span>
      )}
    </div>
  )
})
